










import { CustomLink } from '../../atoms'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    CustomLink
  }
})
export default class LoginBox extends Vue {
  @Prop({ type: String, default: '' }) readonly email?: string
  goToForgotPassword() {
    this.$router.push({ path: '/forgot-password', query: { email: this.email } })
  }
}
